import { MessageCircle, Truck, SearchCheck, Wrench, ClipboardCheck, ShieldCheck, ArrowRight } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { useSiteConfig } from "@/context/SiteConfigContext";

const STEPS = [
  { icon: MessageCircle, label: "Você chama no WhatsApp" },
  { icon: Truck, label: "Chegamos ao local" },
  { icon: SearchCheck, label: "Detectamos o vazamento" },
  { icon: Wrench, label: "Realizamos o reparo" },
  { icon: ClipboardCheck, label: "Teste de estanqueidade" },
  { icon: ShieldCheck, label: "Liberação do sistema" },
];

export const HowItWorks = () => {
  const cfg = useSiteConfig();
  const steps = cfg.steps?.length ? cfg.steps : STEPS;

  return (
  <section id="como-funciona" className="bg-white py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Chapter num="03 — Passo a passo" title="Como funciona" accent="nosso atendimento" />
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-6 lg:gap-3">
        {steps.map((s, i) => {
          const IconCmp = STEPS[i % STEPS.length].icon;
          return (
          <Reveal key={i} delay={i * 0.1} className="relative">
            <div className="flex flex-col items-center text-center" data-testid={`step-${i}`}>
              <span className="font-display text-sm font-bold text-zinc-300">0{i + 1}</span>
              <span className="mt-2 flex h-[72px] w-[72px] items-center justify-center rounded-full border-4 border-[var(--primary)]/20 bg-[var(--primary)] shadow-[0_12px_30px_-8px_rgba(255,184,0,0.6)] transition-transform duration-300 hover:scale-110">
                <IconCmp size={28} className="text-black" />
              </span>
              <p className="mt-4 max-w-[140px] font-display text-base font-semibold uppercase leading-tight text-zinc-800">
                {s.label}
              </p>
            </div>
            {i < steps.length - 1 && (
              <ArrowRight size={20} className="absolute -right-4 top-12 hidden text-zinc-300 lg:block" />
            )}
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
  );
};
